module.exports = __webpack_public_path__ + "img/arrange.2666f132.svg";